import { Badge, Button, LabelCaps } from '@pm/ui';
import { Building2, LogOut } from 'lucide-react';
import { useState } from 'react';
import { useNavigate } from 'react-router';
import { useAuth, useMe } from '@/lib/auth';

/** Usuário em várias organizações escolhe o tenant ativo. */
export function SelectOrganizationPage() {
  const me = useMe();
  const { selectOrganization, logout } = useAuth();
  const navigate = useNavigate();
  const [busy, setBusy] = useState<string | null>(null);
  const [error, setError] = useState<string | null>(null);

  async function choose(id: string) {
    setBusy(id);
    setError(null);
    try {
      await selectOrganization(id);
      void navigate('/', { replace: true });
    } catch (err) {
      setError(err instanceof Error ? err.message : 'Não foi possível selecionar.');
      setBusy(null);
    }
  }

  return (
    <main className="grid min-h-screen place-items-center bg-bg p-4">
      <div className="glass w-full max-w-[440px] rounded-lg p-6 shadow-overlay">
        <LabelCaps>Organização</LabelCaps>
        <h1 className="mt-1 text-lg font-medium">Onde você quer trabalhar?</h1>
        <p className="mt-1 text-sm text-text-2">
          Olá, {me.user.name}. Você faz parte de mais de uma organização.
        </p>

        <ul className="mt-5 flex flex-col gap-2">
          {me.organizations.map((org) => (
            <li key={org.id}>
              <button
                type="button"
                onClick={() => void choose(org.id)}
                disabled={busy !== null}
                className="flex w-full items-center gap-3 rounded-md border border-border bg-surface-1 px-3.5 py-3 text-left transition-[border-color,box-shadow] duration-(--dur-fast) hover:border-accent-border hover:shadow-glow focus-visible:outline-none focus-visible:shadow-ring disabled:opacity-60"
              >
                <Building2 className="size-4 text-text-2" aria-hidden />
                <span className="flex-1">
                  <span className="block font-medium">{org.name}</span>
                  <span className="block font-mono text-xs text-text-3">/{org.slug}</span>
                </span>
                <Badge tone={org.mode === 'AGENCY' ? 'accent' : 'info'}>
                  {org.mode === 'AGENCY' ? 'Agência' : 'Interno'}
                </Badge>
              </button>
            </li>
          ))}
          {me.organizations.length === 0 ? (
            <li className="rounded-md border border-border bg-surface-1 p-4 text-sm text-text-2">
              Sua conta não está vinculada a nenhuma organização ativa.
            </li>
          ) : null}
        </ul>

        {error ? (
          <p role="alert" className="mt-3 text-sm text-danger">
            {error}
          </p>
        ) : null}

        <div className="mt-5 flex justify-end">
          <Button variant="ghost" size="sm" onClick={() => void logout()}>
            <LogOut /> Sair
          </Button>
        </div>
      </div>
    </main>
  );
}
